import { message } from 'antd';
import { GENERAL_ERRORS, HISCON_ERRORS } from '~/typings/enums/ErrorsType';

const getErrorMessage = (errors: Record<string, string>, type: string) => errors[type] || type;

type ErrorHandlerOptions = {
  defaultMessage?: string;
  duration?: number;
  ignoreErrorStatus?: number[];
};

const errorHandlerCreate = (errors: Record<string, string>) => (err: any, options?: ErrorHandlerOptions) => {
  const status = err?.response?.status;
  const userMessages = err?.response?.data?.userMessage;
  const systemMessages = err?.response?.data?.messages;
  const messages = userMessages ? [userMessages] : systemMessages;

  if (status !== undefined && options?.ignoreErrorStatus?.includes(status)) {
    return;
  }

  if (messages?.length) {
    messages.map((msg) =>
      message.error(
        getErrorMessage(errors, msg.text) ||
          getErrorMessage(errors, msg) ||
          options?.defaultMessage ||
          'Ocorreu um erro',
        options?.duration,
      ),
    );
  } else {
    message.error(options?.defaultMessage || 'Ocorreu um erro', options?.duration);
  }
};

export const handleErrors = errorHandlerCreate(GENERAL_ERRORS);
export const handleHisconErrors = errorHandlerCreate(HISCON_ERRORS);

/**
 * Mostra o texto do servidor so quando a resposta traz um errorCode (erro de negocio com mensagem
 * pensada para o usuario, ex.: CEP fora da base dos Correios). Sem errorCode o telli costuma mandar
 * texto tecnico (ex.: `e.toString()`, "FORBIDDEN"), entao vale a mensagem padrao da tela. Sessao
 * expirada (401) segue sem aviso, como no tratamento global.
 */
export const handleBusinessErrors = (err: any, options: ErrorHandlerOptions & { defaultMessage: string }) => {
  if (err?.response?.status === 401) {
    return;
  }

  if (err?.response?.data?.errorCode) {
    handleErrors(err, options);
    return;
  }

  message.error(options.defaultMessage, options.duration);
};
